<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 v-t="'entities.locale.name_plural'" class="mt-0"></h1>

      <div>
        <el-autocomplete
          v-model="namespace"
          :fetch-suggestions="fetchNamespaces"
          clearable
        >
          <template slot="prepend">{{ namespaceLabel }}</template>
        </el-autocomplete>
        <el-button @click="refresh" v-t="'common.refresh'" class="ml-3"></el-button>
      </div>
    </div>

    <create-locale-dialog
      :visible.sync="createLocaleDialog.visible"
      :value="createLocaleDialog.value"
      @closed="onClosedCreateLocaleDialog"
    />

    <el-tabs v-model="activeTab">
      <el-tab-pane :label="tabExistingLabel" name="existing" lazy>
        <locale-grid
          ref="existingLocalesGrid"
          :namespace="namespace"
        />
      </el-tab-pane>

      <el-tab-pane :label="tabIncompleteLabel" name="incomplete" lazy>
        <incomplete-locale-grid
          ref="incompleteLocalesGrid"
          :namespace="namespace"
          @click:showCreateLocaleDialog="showCreateLocaleDialog"
        />
      </el-tab-pane>

      <el-tab-pane :label="tabMissingLabel" name="missing" lazy>
        <missing-locale-grid
          ref="missingLocalesGrid"
          :namespace="namespace"
          @click:showCreateLocaleDialog="showCreateLocaleDialog"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { pick } from 'lodash';
import CreateLocaleDialog from '@/components/CreateLocaleDialog.vue';
import IncompleteLocaleGrid from '@/components/IncompleteLocaleGrid.vue';
import LocaleGrid from '@/components/LocaleGrid.vue';
import MissingLocaleGrid from '@/components/MissingLocaleGrid.vue';
import { translateProperty } from '@/lib/util';

export default {
  name: 'Locales',
  components: {
    CreateLocaleDialog,
    LocaleGrid,
    IncompleteLocaleGrid,
    MissingLocaleGrid,
  },
  data() {
    return {
      activeTab: 'existing',
      namespace: 'default',
      namespaces: ['default', 'test'],
      createLocaleDialog: {
        visible: false,
        value: null,
      },
    };
  },
  computed: {
    activeGrid() {
      switch (this.activeTab) {
        case 'existing':
          return this.$refs.existingLocalesGrid;
        case 'incomplete':
          return this.$refs.incompleteLocalesGrid;
        case 'missing':
          return this.$refs.missingLocalesGrid;
        default:
          return null; // should not happen
      }
    },
    namespaceLabel() {
      return translateProperty('locale', 'namespace');
    },
    tabExistingLabel() {
      return this.$t('views.locales.tabs.existing.label');
    },
    tabIncompleteLabel() {
      return this.$t('views.locales.tabs.incomplete.label');
    },
    tabMissingLabel() {
      return this.$t('views.locales.tabs.missing.label');
    },
  },
  watch: {
    activeTab() {
      // tab might not be loaded
      this.$nextTick(() => {
        this.refresh();
      });
    },
  },
  methods: {
    refresh() {
      this.activeGrid.refresh();
      this.$i18n.i18next.reloadResources();
    },
    fetchNamespaces(query, callback) {
      const data = this.namespaces
        .map(namespace => ({ value: namespace }));

      callback(data);
    },
    showCreateLocaleDialog(incompleteLocale) {
      this.createLocaleDialog.value = pick(incompleteLocale, ['namespace', 'key', 'language']);
      this.createLocaleDialog.visible = true;
    },
    onClosedCreateLocaleDialog() {
      this.createLocaleDialog.value = null;
      this.refresh();
    },
  },
};
</script>

<style scoped>

</style>
